const KEY = "opentool-desktop-icons";
const DEFAULTS = ["chat", "browser", "notebook", "files", "settings"];

export function getDesktopIconIds(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [...DEFAULTS];
    return JSON.parse(raw);
  } catch {
    return [...DEFAULTS];
  }
}

export function setDesktopIconIds(ids: string[]): void {
  localStorage.setItem(KEY, JSON.stringify(ids));
}

export function addToDesktop(id: string): void {
  const ids = getDesktopIconIds();
  if (!ids.includes(id)) setDesktopIconIds([...ids, id]);
}

export function removeFromDesktop(id: string): void {
  setDesktopIconIds(getDesktopIconIds().filter((i) => i !== id));
}

export function isOnDesktop(id: string): boolean {
  return getDesktopIconIds().includes(id);
}
